var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSemi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 19,
    viewBox: "0 0 7 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12442 16.4493C1.40135 16.4493 0.0045166 15.0524 0.0045166 13.3294C0.0045166 11.6063 1.40135 10.2095 3.12442 10.2095C4.84749 10.2095 6.24432 11.6063 6.24432 13.3294C6.24432 17.4188 1.25431 18.2137 1.25431 18.2137L0.960243 17.1155C0.960243 17.1155 1.57136 16.8674 2.0676 16.2655",
    fill: "#2D91FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1199 6.23981C4.84298 6.23981 6.23981 4.84298 6.23981 3.11991C6.23981 1.39683 4.84298 0 3.1199 0C1.39683 0 0 1.39683 0 3.11991C0 4.84298 1.39683 6.23981 3.1199 6.23981Z",
    fill: "#2D91FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemi);
export default __webpack_public_path__ + "static/media/semi.ff67b34a2d57fa2226c366a666ed9b25.svg";
export { ForwardRef as ReactComponent };